/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Doručeno na`
};

const da_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Sendt til`
};

const de_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Geliefert an`
};

const en_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Shipped to`
};

const es_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado a`
};

const fr_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Livré à`
};

const hu_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítva ide`
};

const it_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Consegnato a`
};

const nl_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Geleverd aan`
};

const pl_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Dostarczono do`
};

const pt_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado para`
};

const sv_shipped_to = /** @type {(inputs: {}) => string} */ () => {
	return `Levererad till`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipped_to = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipped_to(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipped_to", locale)
	if (locale === "cs") return cs_shipped_to(inputs)
	if (locale === "da") return da_shipped_to(inputs)
	if (locale === "de") return de_shipped_to(inputs)
	if (locale === "en") return en_shipped_to(inputs)
	if (locale === "es") return es_shipped_to(inputs)
	if (locale === "fr") return fr_shipped_to(inputs)
	if (locale === "hu") return hu_shipped_to(inputs)
	if (locale === "it") return it_shipped_to(inputs)
	if (locale === "nl") return nl_shipped_to(inputs)
	if (locale === "pl") return pl_shipped_to(inputs)
	if (locale === "pt") return pt_shipped_to(inputs)
	return sv_shipped_to(inputs)
};